import { Button } from "@/components/ui/button"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { IconLoader2 } from "@tabler/icons-react"
import { ArrowLeft } from "lucide-react"
import { useNavigate, useParams } from "react-router"
import { useQuestionnaire } from "../../../api/customerRequestsApi"
import { RecordView } from "../RecordView"
import { CUSTOMER_REQUESTS_BASE } from "../routes"

/**
 * Step 3 / detail — the stored questionnaire record. Reached after storing a
 * request (status "stored · pending processing", with the downstream-processing
 * handoff) and when opening a row from the inbox.
 */
export function CustomerRequestRecordPage() {
  const { translate } = useTranslation()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()

  const { data: row, isLoading } = useQuestionnaire(id ?? null)

  if (isLoading) {
    return (
      <div className="flex min-h-[400px] items-center justify-center">
        <IconLoader2 size={22} className="animate-spin text-grey5" />
      </div>
    )
  }

  if (!row) {
    return (
      <div className="mx-auto w-full max-w-[720px]">
        <div className="mb-3.5">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(CUSTOMER_REQUESTS_BASE)}
          >
            <ArrowLeft size={14} className="mr-1.5" />
            {translate("MC_Q_RECORD_BTN_BACK")}
          </Button>
        </div>
        <div className="rounded-xl border border-grey4 bg-grey2 p-8 text-center text-[13px] text-grey5">
          {translate("MC_Q_RECORD_NOT_FOUND")}
        </div>
      </div>
    )
  }

  return (
    <RecordView row={row} onBack={() => navigate(CUSTOMER_REQUESTS_BASE)} />
  )
}
